<template>
  <b-modal
    :id="`show-${type}-video-modal`"
    :title="capitalize(type)"
    no-enforce-focus
    size="xl"
    hide-footer
  >
    <b-row>
      <b-col v-if="video">
        <iframe v-if="type == 'youtube'" width="560" height="315" :src="`https://www.youtube.com/embed/${video.id}`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <div v-if="type == 'vimeo'" style="padding:56.25% 0 0 0;position:relative;">
          <iframe :src="`https://player.vimeo.com/video/${video.id}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=164141`" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen :title="video.name"></iframe>
        </div>
      </b-col>

      <b-col v-if="video" class="mt-3">
        <h5>{{ video.name }}</h5>
        <p v-if="type == 'vimeo'">
          <b-badge
            v-if="!video.am_gated"
            :variant="video.privacy == 'anybody' ? 'success' : 'danger'"
            class="mt-2"
          >
            {{ trans('vimeo_privacy_' + video.privacy) }}
          </b-badge>
          <b-badge v-if="video.am_gated" variant="info" class="mt-2">
            {{ trans('vimeo_privacy_gated') }}
          </b-badge>
        </p>
        <p>{{ video.description }}</p>
        <b-form-group>
          <b-input-group class="my-2">
            <b-form-input :value="video.url" readonly></b-form-input>
            <b-input-group-append v-if="!video.am_gated">
              <b-button variant="outline-primary" v-clipboard:copy="video.url" :title="trans('copy')" v-b-tooltip.hover class="px-2">
                <i class="fa fa-fw fa-copy"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-row>
          <b-col class="col-auto">
            <a :href="`/organization/${this.organization.id}/sendout/create?${type}=${encodeURIComponent(video.id)}`" class="btn btn-primary">
              <i class="fa fa-fw fa-comment"></i>
              {{ trans('send') }}
            </a>
          </b-col>
          <b-col class="text-right">
            <a v-if="!video.am_gated" :href="video.url" target="_blank" class="btn btn-link">
              {{ trans('watch_on') }} {{ capitalize(type) }}
              <i class="fa fa-fw fa-external-link-alt"></i>
            </a>
            <br/>
            <a v-if="type == 'vimeo'" :href="video.manage_url" target="_blank" class="btn btn-link">
              {{ trans('manage_on') }} {{ capitalize(type) }}
              <i class="fa fa-fw fa-external-link-alt"></i>
            </a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <vimeo-gated
      v-if="type == 'vimeo' && vimeo_user && organization.id == 8 && video"
      :organization="organization"
      :video_id="video.id"
      :vimeo_user="vimeo_user"
      class="mt-3"
    ></vimeo-gated>

  </b-modal>
</template>

<script>
  import VimeoGated from './VimeoGated'

  export default {
    props: {
      organization: Object,
      vimeo_user: Object,
      video: Object,
      type: String,
    },
    components: {
      VimeoGated,
    },
    data() {
      return {
        trans: trans,
        capitalize: _.capitalize,
        showAdminTools: window.SHOW_ADMIN_TOOLS,
      }
    },
    mounted() {
      window[this.type+'Modal'] = this
    },
  }
</script>